"use client";
import {
  Center,
  Separator,
  Flex,
  Grid,
  GridItem,
  HStack,
  List,
  Stack,
} from "@chakra-ui/react";
import Image from "next/image";
import TickImage from "public/shared/check-box.png";
import DottedBgImage from "public/shared/dottedGradientBg.svg";
import { useHeadingVariant, useTextVariant } from "@/theme/hooks/useSectionStyle";
import { Heading, Text, Button } from "@/elements";
import { scrollToElement } from "@/utils/scrollToElement";
import { WHY_ONEMIND_CONSTANTS } from "./constants";

const WhyOnemind = () => {
  const HeadingVariants = useHeadingVariant();
  const TextVariant = useTextVariant();
  const { title, image, points1, list, points2 } = WHY_ONEMIND_CONSTANTS;
  return (
    <Grid
      gap={{ base: 3, md: 8 }}
      bgImage={`url(${DottedBgImage.src})`}
      backgroundPosition={"center"}
      bgSize={"cover"}
      templateColumns={{
        base: "repeat(1, 1fr)",
        md: "repeat(4, 1fr)",
      }}
      p={{ base: 6, md: 12 }}
      borderRadius={"8px"}
      mx="auto"
    >
      <GridItem colSpan={{ base: 1, md: 1 }}>
        <Center height={"full"}>
          <Heading as="h2" variant={HeadingVariants} textAlign={"center"} color="white">
            {title}
          </Heading>
        </Center>
      </GridItem>
      <GridItem colSpan={{ base: 1, md: 3, lg: 2 }} pt={{ base: 4, md: 0 }}>
        <Flex direction={{ base: "column", md: "row" }} alignItems="center" height="100%">
          <Separator
            orientation="vertical"
            color="white"
            height="100%"
            borderWidth={"1px"}
            display={{ base: "none", md: "block" }}
          />
          <Stack ml={{ md: 12 }} mr={{ lg: 12 }} gap={4}>
            <Stack gap={4} color="white">
              {points1.map((point, index) => (
                <HStack key={index} align={"start"}>
                  <Image
                    alt={"Point"}
                    src={TickImage}
                    style={{ height: "auto", width: "20px", paddingTop: "4px" }}
                  />{" "}
                  <Text
                    variant={TextVariant}
                    color="white"
                    fontWeight={{ base: 500, md: 550 }}
                  >
                    {point}
                  </Text>
                </HStack>
              ))}
            </Stack>
            <HStack align={"start"}>
              <Image
                alt={"Point"}
                src={TickImage}
                style={{ height: "auto", width: "20px", paddingTop: "4px" }}
              />{" "}
              <Text variant={TextVariant} fontWeight={600} color="white">
                {list.title}
              </Text>
            </HStack>
            <List.Root ml={{ md: 12 }} gap={2}>
              {list.points.map((point, index) => (
                <List.Item key={index} color="white">
                  <Text variant={TextVariant}>{point}</Text>
                </List.Item>
              ))}
            </List.Root>
            <Stack gap={4} color="white">
              {points2.map((point, index) => (
                <HStack key={index} align={"start"}>
                  <Image
                    alt={"Point"}
                    src={TickImage}
                    style={{ height: "auto", width: "20px", paddingTop: "4px" }}
                  />{" "}
                  <Text
                    variant={TextVariant}
                    style={{ lineHeight: "24px" }}
                    fontWeight={{ base: 500, md: 550 }}
                    color="white"
                  >
                    {point}
                  </Text>
                </HStack>
              ))}
            </Stack>
            <Button
              variant={"outline"}
              mt={4}
              onClick={() => scrollToElement("contact-us", 120)}
              w="fit-content"
              alignSelf={{ lg: "center" }}
            >
              Get Started Today
            </Button>
          </Stack>
          <Separator
            orientation="vertical"
            color="white"
            height="100%"
            borderWidth={"1px"}
            display={{ base: "none", lg: "block" }}
          />
        </Flex>
      </GridItem>

      <GridItem colSpan={{ base: 1, md: 4, lg: 1 }}>
        <Center height={"full"}>
          <Image
            src={image}
            alt={"image"}
            style={{
              maxHeight: "300px",
              objectFit: "contain",
              objectPosition: "center",
            }}
          />
        </Center>
      </GridItem>
    </Grid>
  );
};

export default WhyOnemind;
